import { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import {
  HomeOutlined,
  AppstoreAddOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  AppLayout,
  ContentLayout,
  SpaceBetween,
  Container,
  Form,
  FormField,
  Input,
} from "@cloudscape-design/components";

import DateRangePicker from "@cloudscape-design/components/date-range-picker";

const { Header, Content, Sider, Footer } = Layout;

export function TimeMachine() {
  const [navOpen, setNavOpen] = useState(true);
  const toggleNav = () => {
    setNavOpen(navOpen ^ 1);
  };
  document.title = "YouTube Time Machine | Hansoftware";

  const [channelID, setChannelID] = useState("");
  const [dateRange, setDateRange] = useState({
    type: "absolute",
    startDate: "",
    endDate: "",
  });

  function channelIDregex(inputField) {
    let regex = /^UC[\w-]{22}$/;
    let validID = regex.test(inputField);
    if (validID) {
      return "";
    } else if (!validID) {
      return "Please enter a valid YouTube Channel ID";
    } else {
      return "";
    }
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout>
        {/* Main Content */}
        <Layout style={{ padding: "0 24px 24px" }}>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: "#fff",
            }}
          >
            <h1>YouTube Time Machine</h1>
            <h3>
              Get YouTube videos from your favorite creators in previous years!
            </h3>
            <p>
              First, enter the channel ID, found by going to a channel's
              description, clicking 'Share channel', then 'Copy channel ID'
            </p>
            <p>
              Now, select a date range, or select "Today" (our personal favorite
              method).
            </p>
            <Container fitHeight>
              <SpaceBetween direction="vertical" size="m">
                <FormField
                  label="Channel ID"
                  warningText={channelIDregex(channelID)}
                >
                  <Input
                    onChange={({ detail }) => setChannelID(detail.value)}
                    value={channelID}
                    placeholder="Example: UCIDlKYC7I6_76jCUBdX-6VQ"
                  />
                </FormField>
                <FormField label="Date Range">
                  <DateRangePicker
                    onChange={({ detail }) => setDateRange(detail.value)}
                    value={dateRange}
                    isValidRange={(range) => {
                      if (range.type === "absolute") {
                        const [startDateWithoutTime] =
                          range.startDate.split("T");
                        const [endDateWithoutTime] = range.endDate.split("T");
                        if (!startDateWithoutTime || !endDateWithoutTime) {
                          return {
                            valid: false,
                            errorMessage:
                              "The selected date range is incomplete. Select a start and end date for the date range.",
                          };
                        }
                        if (
                          new Date(range.startDate) - new Date(range.endDate) >
                          0
                        ) {
                          return {
                            valid: false,
                            errorMessage:
                              "The selected date range is invalid. The start date must be before the end date.",
                          };
                        }
                      }
                      return { valid: true };
                    }}
                    i18nStrings={{}}
                    placeholder="Filter by a date and time range"
                  />
                </FormField>
              </SpaceBetween>
            </Container>
          </Content>
        </Layout>
      </Layout>

      {/* Footer */}
      <Footer
        style={{
          textAlign: "center",
          backgroundColor: "#001529",
          color: "white",
        }}
      >
        Hansoftware © {Date.now()}
      </Footer>
    </Layout>
  );
}

export default TimeMachine;
